export type { ContextMenuItem, MapLayer, TileLayer } from '@/lib/leaflet/leafletMap';

export type LatLng = {
  lat: number;
  lng: number;
};

export type MapPoint = [x: number, y: number];

export type MapCircle = {
  latLng: LatLng;
  radius: number;
  color: string;
  opacity?: number;
  fillColor?: string;
  fillOpacity?: number;
};

export type PolylineOptions = {
  stroke?: boolean;
  color?: string;
  weight?: number;
  opacity?: number;
};

export type MapPath = {
  points: LatLng[];
  options: PolylineOptions;
};

export const CONTEXT_MENU_CHANGE_CALLER_LOCATION = 'change-caller-location';
